// config.js - Centralized configuration

export const CONFIG = {
    // WS/backend service base
    API_BASE: import.meta.env.VITE_API_URL || "https://ws.cyberschooling.eu",

    // Same-origin auth/child API base
    AUTH_API_BASE: import.meta.env.VITE_AUTH_API_URL || "",

    // Same-origin app/curriculum API base
    APP_API_BASE: import.meta.env.VITE_APP_API_URL || "",
    CURRICULUM_API_BASE: import.meta.env.VITE_CURRICULUM_API_URL || "",

    // WebSocket URL
    WS_URL: "wss://ws.cyberschooling.eu/ws",

    // Audio settings
    SAMPLE_RATE: 16000,
    BUFFER_SIZE: 4096
};

// Aliases for backwards compatibility
CONFIG.WS_API_BASE = CONFIG.API_BASE;
